import React, { useState, useEffect, useRef } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import { Dimmer } from "../spinner";
import axios from "axios";
import moment from "moment";
import useTableScroll from "../useTableScrollcesar";
import Modal from "react-bootstrap/Modal";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  validaNumeroTelefono,
  validaEmail,
  seleccionarCampo,
} from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import CatalogoResponExpendio from "../../catalogos/catalogoRspnExp";
import CatalogoActividades from "../../catalogos/catalogoActividades";

const FormTributario = (props) => {
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  let op = require("../../../public/modulos/datos");
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusuarioweb = JSON.parse(localStorage.getItem("idusuarioweb"));

  let anio = JSON.parse(localStorage.getItem("anioactu"));
  const fechaTope = moment(JSON.parse(localStorage.getItem("fechasistema")))
    .format("YYYY-MM-DD")
    .replace(anio.toString(), (anio - 18).toString());

  const headCells = [
    { label: "CODIGO", textAlign: "center" },
    { label: "COD. ACTIVIDAD", textAlign: "center" },
    { label: "DESCRIPCIÓN", textAlign: "center" },
    { label: "OPCIONES", textAlign: "center" },
  ];

  const txtTipoRif = useRef();
  const txtNacionalidad = useRef();
  const txtCedula = useRef();
  const txtNombreRespon = useRef();
  const txtApellidos = useRef();
  const txtSexo = useRef();
  const txtDireccionRespon = useRef();
  const txtFnacimiento = useRef();
  const txtCorreoRespon = useRef();
  const txtTlf1 = useRef();
  const txtTlf2 = useRef();
  const btnCancela = useRef();

  const txtTlf1Area = useRef();
  const txtTlf2Area = useRef();

  const txtrazonsocial = useRef();
  const txtdenominacioncomercial = useRef();
  const txtdireccion = useRef();
  const txtciudad = useRef();
  const txtEstado = useRef();
  const txtmunicipio = useRef();
  const txtrif = useRef();
  const txtCodArea = useRef();
  const txttelefono = useRef();
  const txtcappagado = useRef();
  const txtcapsubsc = useRef();
  const txttipocontribnac = useRef();
  const txtoficinaregistro = useRef();
  const txtfecharegistro = useRef();
  const txtprotocolo = useRef();
  const txttomo = useRef();
  const txtfolio = useRef();
  const txtnumero = useRef();
  const txtcorreoepri = useRef();
  const txtcorreoesec = useRef();

  const [mostrar5, setMostrar5] = useState(false);
  const [body, setBody] = useState({});
  const [tipocontribuyente, setTipocontribuyente] = useState([]);
  const [denominacion, setDenominacion] = useState([]);
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [activate, setActivate] = useState(false);
  const [catalogo, setCatalogo] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [habilitado, setHabilitado] = useState(false);
  const [visible, setVisible] = useState("visible");
  const [operacionPer, setOperacionPer] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [solicitud, setSolicitud] = useState({
    idret: 0,
    razonsocial: "",
    denominacioncomercial: "",
    direccion: "",
    ciudad: "",
    rif: "",
    telefono: "",
    responsable: "",
    fechaincripcion: "",
    cappagado: "0,00",
    capsubsc: "0,00",
    tipocontribnac: "",
    status: "",
    oficinaregistro: "",
    fecharegistro: "",
    protocolo: "",
    tomo: "",
    folio: "",
    numero: "",
    correoepri: "",
    correoesec: "",
    municipio: "",
    estado: "",
    nacrepre: "",
  });
  const [persona, setPersona] = useState({
    cedula: "",
    correoe: "",
    tlf1: "",
    tlf2: "",
    apellidos: "",
    direccion: "",
    fnacimiento: "",
    nacionalidad: "",
    nombres: "",
    sexo: "",
  });
  const [records, setRecords] = useState([]);

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const onChange = (event) => {
    if (
      event.target.name === "nombres" ||
      event.target.name === "apellidos" ||
      event.target.name === "direccion" ||
      event.target.name === "correoe"
    ) {
      event.target.value = event.target.value.toUpperCase();
    } else if (
      event.target.name === "nacionalidad" &&
      txtCedula.current.value !== ""
    ) {
      datosRes(txtNacionalidad.current.value, txtCedula.current.value);
    }

    setPersona({ ...persona, [event.target.name]: event.target.value });
  };

  const onChangeSolicitud = (event) => {
    if (
      event.target.name === "razonsocial" ||
      event.target.name === "rif" ||
      event.target.name === "direccion" ||
      event.target.name === "correoepri" ||
      event.target.name === "correoesec" ||
      event.target.name === "oficinaregistro"
    ) {
      event.target.value = event.target.value.toUpperCase();
    } else if (event.target.name === "estado") {
      if (event.target.value !== "") {
        setMunicipios([]);
        setCiudades([]);
        selectMunicipio(event.target.value);
      }
    } else if (event.target.name === "municipio") {
      if (event.target.value !== "") {
        setCiudades([]);
        selectCiudad(event.target.value);
      }
    } else if (event.target.name === "denominacioncomercial") {
      if (event.target.value === "8") {
        setVisible("collapse");
        setRecords([
          {
            idactividad: "4",
            codigoactividad: "000011",
            descripcion: "GOBIERNO",
          },
        ]);
      } else {
        setVisible("visible");
        setRecords([]);
      }
    }

    setSolicitud({ ...solicitud, [event.target.name]: event.target.value });
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    let mon = 0.0;
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtrazonsocial.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar la razon social",
        icono: "informacion",
      });
      txtrazonsocial.current.focus();
      sigue = false;
    } else if (txtTipoRif.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar el tipo de rif",
        icono: "informacion",
      });
      txtTipoRif.current.focus();
      sigue = false;
    } else if (txtrif.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el rif",
        icono: "informacion",
      });
      txtrif.current.focus();
      sigue = false;
    } else if (txtdenominacioncomercial.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar la denominacion social",
        icono: "informacion",
      });
      txtdenominacioncomercial.current.focus();
      sigue = false;
    } else if (txtdireccion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar la direccion",
        icono: "informacion",
      });
      txtdireccion.current.focus();
      sigue = false;
    } else if (txtEstado.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar el estado",
        icono: "informacion",
      });
      txtEstado.current.focus();
      sigue = false;
    } else if (txtmunicipio.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar el municipio",
        icono: "informacion",
      });
      txtmunicipio.current.focus();
      sigue = false;
    } else if (txtciudad.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar la ciudad",
        icono: "informacion",
      });
      txtciudad.current.focus();
      sigue = false;
    } else if (txtCodArea.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el codigo",
        icono: "informacion",
      });
      txtCodArea.current.value = "";
      txtCodArea.current.focus();
      sigue = false;
    } else if (txttelefono.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar un numero de teléfono",
        icono: "informacion",
      });
      txttelefono.current.value = "";
      txttelefono.current.focus();
      sigue = false;
    } else if (txtcorreoepri.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el correo principal",
        icono: "informacion",
      });
      txtcorreoepri.current.focus();
      sigue = false;
    } else if (!validaEmail(txtcorreoepri.current.value.trim())) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar un correo valido",
        icono: "informacion",
      });
      txtcorreoepri.current.value = "";
      txtcorreoepri.current.focus();
      sigue = false;
    } else if (txtcorreoesec.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el correo secundario",
        icono: "informacion",
      });
      txtcorreoesec.current.focus();
      sigue = false;
    } else if (!validaEmail(txtcorreoesec.current.value.trim())) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar un correo valido",
        icono: "informacion",
      });
      txtcorreoesec.current.value = "";
      txtcorreoesec.current.focus();
      sigue = false;
    } else if (txtNacionalidad.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar una nacionalidad",
        icono: "informacion",
      });
      txtNacionalidad.current.focus();
      sigue = false;
    } else if (txtCedula.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el N° de cedula",
        icono: "informacion",
      });
      txtCedula.current.focus();
      sigue = false;
    } else if (txtNombreRespon.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar los nombres del responsable",
        icono: "informacion",
      });
      txtNombreRespon.current.focus();
      sigue = false;
    } else if (txtApellidos.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar los apellidos del responsable",
        icono: "informacion",
      });
      txtApellidos.current.focus();
      sigue = false;
    } else if (txtSexo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el sexo del responsable",
        icono: "informacion",
      });
      txtSexo.current.focus();
      sigue = false;
    } else if (txtDireccionRespon.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar la direccion del responsable",
        icono: "informacion",
      });
      txtDireccionRespon.current.focus();
      sigue = false;
    } else if (txtFnacimiento.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar la fecha de nacimiento del responsable",
        icono: "informacion",
      });
      txtFnacimiento.current.focus();
      sigue = false;
    } else if (txtCorreoRespon.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar los apellidos del responsable",
        icono: "informacion",
      });
      txtCorreoRespon.current.focus();
      sigue = false;
    } else if (!validaEmail(txtCorreoRespon.current.value.trim())) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar un correo valido",
        icono: "informacion",
      });
      txtCorreoRespon.current.value = "";
      txtCorreoRespon.current.focus();
      sigue = false;
    } else if (txtfecharegistro.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar la fecha del registro",
        icono: "informacion",
      });
      txtfecharegistro.current.focus();
      sigue = false;
    } else if (txtprotocolo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el protocolo",
        icono: "informacion",
      });
      txtprotocolo.current.focus();
      sigue = false;
    } else if (txttomo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el tomo",
        icono: "informacion",
      });
      txttomo.current.focus();
      sigue = false;
    } else if (txtfolio.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el folio",
        icono: "informacion",
      });
      txtfolio.current.focus();
      sigue = false;
    } else if (txtnumero.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el numero del registro",
        icono: "informacion",
      });
      txtnumero.current.focus();
      sigue = false;
    } else if (txtoficinaregistro.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar la oficina de registro",
        icono: "informacion",
      });
      txtoficinaregistro.current.focus();
      sigue = false;
    } else if (txtcapsubsc.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el capital subscrito",
        icono: "informacion",
      });
      txtcapsubsc.current.focus();
      sigue = false;
    } else if (txtcappagado.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el capital pagado",
        icono: "informacion",
      });
      txtcappagado.current.focus();
      sigue = false;
    } else if (txttipocontribnac.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar el tipo de contribuyente",
        icono: "informacion",
      });
      txttipocontribnac.current.focus();
      sigue = false;
    } else if (records.length === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe agregar una actividad comercial.",
        icono: "informacion",
      });
      sigue = false;
    }

    if (sigue) {
      var solic = [];
      var repre = [];
      solic.push({
        idret: solicitud.idret,
        razonsocial: txtrazonsocial.current.value.trim(),
        denominacioncomercial: txtdenominacioncomercial.current.value.trim(),
        direccion: txtdireccion.current.value.trim(),
        ciudad: txtciudad.current.value.trim(),
        rif: txtTipoRif.current.value.trim() + txtrif.current.value.trim(),
        telefono:
          txtCodArea.current.value.trim() + txttelefono.current.value.trim(),
        responsable: txtCedula.current.value.trim(),
        fechaincripcion: fechaSistema,
        cappagado: txtcappagado.current.value
          .trim()
          .replace(/\./g, "")
          .replace(",", "."),
        capsubsc: txtcapsubsc.current.value
          .trim()
          .replace(/\./g, "")
          .replace(",", "."),
        tipocontribnac: txttipocontribnac.current.value.trim(),
        oficinaregistro: txtoficinaregistro.current.value.trim(),
        fecharegistro: txtfecharegistro.current.value.trim(),
        protocolo: txtprotocolo.current.value.trim(),
        tomo: txttomo.current.value.trim(),
        folio: txtfolio.current.value.trim(),
        numero: txtnumero.current.value.trim(),
        correoepri: txtcorreoepri.current.value.trim(),
        correoesec: txtcorreoesec.current.value.trim(),
        municipio: txtmunicipio.current.value.trim(),
        estado: txtEstado.current.value.trim(),
        nacrepre: txtNacionalidad.current.value.trim(),
        idusuarioweb: idusuarioweb,
      });
      repre.push({
        cedula: parseInt(txtCedula.current.value),
        correoe: txtCorreoRespon.current.value.trim(),
        tlf1: txtTlf1Area.current.value + txtTlf1.current.value.trim(),
        tlf2: txtTlf2Area.current.value + txtTlf2.current.value.trim(),
        apellidos: txtApellidos.current.value.trim(),
        direccion: txtDireccionRespon.current.value.trim(),
        fnacimiento: txtFnacimiento.current.value.trim(),
        nacionalidad: txtNacionalidad.current.value.trim(),
        nombres: txtNombreRespon.current.value.trim(),
        sexo: txtSexo.current.value.trim(),
      });

      setBody({
        operacionper: operacionPer,
        solic: solic,
        repre: repre,
        clases: records,
      });

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: "Esta Seguro de Registrar estos Datos.",
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/ret/actualizar/${props.operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "registro creado correctamente",
            icono: "exito",
          });

          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SeleccionarDenominacion = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "denominacioncomercial";
    let orden = "iddenominacioncomercial";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setDenominacion(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SeleccionarTipoContribuyente = () => {
    setActivate(true);

    let campos = "idtipocontribuyente, trim(descripcion) as descripcion";
    let nomtab = "tipocontribuyente";
    let orden = "idtipocontribuyente";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setTipocontribuyente(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const selectEstados = () => {
    let campos = "*";
    let nomtab = "estado";
    let orden = "idestado";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setEstados(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectMunicipio = (id) => {
    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idestado";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMunicipios(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectCiudad = (id) => {
    let campos = "*";
    let nomtab = "ciudad";
    let nomid = "idmunicipio";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setCiudades(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cargarActividades = (id) => {
    let campos = "*";
    let nomtab = "actividadxret";
    let nomid = "idret";
    let nomtab2 = "actividad";
    let nomid2 = "idactividad";
    let endpoint = `${op.conexion}/api/consulta/modeliid2?campos=${campos}&id=${id}&nomtab=${nomtab}&nomtab2=${nomtab2}&nomid=${nomid}&nomid2=${nomid2}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleAceptaCatalogoPer = (
    ced,
    corr,
    tlf1,
    tlf2,
    ape,
    direc,
    fcn,
    nac,
    nom,
    sex
  ) => {
    setCatalogo(false);
    setHabilitadoNU(false);
    setOperacionPer(0);
    txtNombreRespon.current.value = nom;
    setPersona({
      ...persona,
      cedula: ced,
      correoe: corr !== null ? corr.trim() : "",
      tlf1: tlf1 !== null ? tlf1.trim() : "",
      tlf2: tlf2 !== null ? tlf2.trim() : "",
      apellidos: ape !== null ? ape.trim() : "",
      direccion: direc !== null ? direc.trim() : "",
      fnacimiento: fcn !== null ? moment(fcn).format("YYYY-MM-DD") : "",
      nacionalidad: nac !== null ? nac.toString().trim() : "",
      nombres: nom !== null ? nom.trim() : "",
      sexo: sex !== null ? sex.toString().trim() : "",
    });
  };

  const handleAceptaCatalogoAct = (id, desc, cod) => {
    setMostrar5(false);
    /*     setHabilitadoNU(false);
        setOperacionPer(0); */
    var act = [];
    let seguir = true;

    if (records.length > 0) {
      for (let i = 0; i < records.length; i++) {
        act.push(records[i]);

        if (parseInt(id) === parseInt(records[i].idactividad)) {
          seguir = false;
        }
      }

      if (seguir) {
        act.push({
          idactividad: id,
          descripcion: desc,
          codigoactividad: cod,
        });
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "esta actividad ya fue seleccionada.",
          icono: "informacion",
        });
      }
    } else {
      act.push({
        idactividad: id,
        descripcion: desc,
        codigoactividad: cod,
      });
    }

    setRecords(act);
  };

  const eliminarActividad = (item) => (e) => {
    var act = [];

    if (records.length > 0) {
      for (let i = 0; i < records.length; i++) {
        if (item.idactividad !== records[i].idactividad) {
          act.push(records[i]);
        }
      }
    }

    setRecords(act);
  };

  /* valdar buscador por numero cedula */
  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (txtNacionalidad.current.value !== "") {
          datosRes(txtNacionalidad.current.value, txtCedula.current.value);
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "debe seleccionar la nacionalidad.",
            icono: "informacion",
          });
          txtNacionalidad.current.focus();
        }
      }
    }
  };

  const validarRif = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
  };

  const validarNumero = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
  };

  const datosRes = (n, c) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";
    let nomid2 = "nacionalidad";
    let id = c;
    let id2 = n;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setHabilitadoNU(true);
          txtNombreRespon.current.value = "";
          txtApellidos.current.value = "";
          txtSexo.current.value = "";
          txtDireccionRespon.current.value = "";
          txtFnacimiento.current.value = "";
          txtCorreoRespon.current.value = "";
          txtTlf1.current.value = "";
          txtTlf2.current.value = "";

          txtTlf1Area.current.value = "";
          txtTlf2Area.current.value = "";

          if (response.data !== "") {
            setHabilitadoNU(false);
            setOperacionPer(0);
            txtNacionalidad.current.value =
              response.data.nacionalidad.toString();
            txtCedula.current.value = response.data.cedula;
            txtNombreRespon.current.value = response.data.nombres;
            txtApellidos.current.value = response.data.apellidos;
            txtSexo.current.value = response.data.sexo.toString();
            txtDireccionRespon.current.value = response.data.direccion;
            txtFnacimiento.current.value = moment(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            txtCorreoRespon.current.value = response.data.correoe;
            txtTlf1.current.value = response.data.tlf1.substring(4, 11);
            txtTlf2.current.value = response.data.tlf2.substring(4, 11);

            txtTlf1Area.current.value = response.data.tlf1.substring(0, 4);
            txtTlf2Area.current.value = response.data.tlf2.substring(0, 4);

            /*           setPersona({
                      ...persona,
                      cedula: response.data.cedula,
                      correoe: response.data.correoe,
                      tlf1: response.data.tlf1,
                      tlf2: response.data.tlf2,
                      apellidos: response.data.apellidos,
                      direccion: response.data.direccion,
                      fnacimiento: moment(response.data.fnacimiento).format('YYYY-MM-DD'),
                      nacionalidad: response.data.nacionalidad.toString(),
                      nombres: response.data.nombres,
                      sexo: response.data.sexo.toString()
                    }); */
            txtfecharegistro.current.focus();
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            txtNombreRespon.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        console.log(error);
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setMostrar5(false);
    setBody({});
    setTipocontribuyente([]);
    setDenominacion([]);
    setMunicipios([]);
    setCiudades([]);
    setActivate(false);
    setCatalogo(false);
    setHabilitadoNU(false);
    setOperacionPer(0);
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });

    setSolicitud({
      idret: 0,
      razonsocial: "",
      denominacioncomercial: "",
      direccion: "",
      ciudad: "",
      rif: "",
      telefono: "",
      responsable: "",
      fechaincripcion: "",
      cappagado: "0,00",
      capsubsc: "0,00",
      tipocontribnac: "",
      status: "",
      oficinaregistro: "",
      fecharegistro: "",
      protocolo: "",
      tomo: "",
      folio: "",
      numero: "",
      correoepri: "",
      correoesec: "",
      municipio: "",
      estado: "",
      nacrepre: "",
    });
    setPersona({
      cedula: "",
      correoe: "",
      tlf1: "",
      tlf2: "",
      apellidos: "",
      direccion: "",
      fnacimiento: "",
      nacionalidad: "",
      nombres: "",
      sexo: "",
    });
    setRecords([]);
  };

  const cerrarModal = () => {
    props.onHide(true);
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const llenarCampos = () => {
    SeleccionarDenominacion();
    SeleccionarTipoContribuyente();
    selectEstados();

    if (props.operacion === 4 || props.operacion === 3) {
      setHabilitado(true);
    } else {
      setHabilitado(false);
    }

    if (props.operacion !== 1) {
      selectMunicipio(props.ret.estado);
      selectCiudad(props.ret.municipio);
      cargarActividades(props.ret.idret);
      txtNacionalidad.current.value = props.ret.nacrepre.trim();
      txtCedula.current.value = props.ret.responsable;

      txtTipoRif.current.value = props.ret.rif.substring(0, 1);
      txtrif.current.value = props.ret.rif.substring(1, 10);
      txtcapsubsc.current.value = formatMoneda(
        props.ret.capsubsc.replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
      txtcappagado.current.value = formatMoneda(
        props.ret.cappagado.replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
      txtrazonsocial.current.value = props.ret.razonsocial.trim();
      txtdenominacioncomercial.current.value =
        props.ret.denominacioncomercial.trim();
      txtdireccion.current.value = props.ret.direccion.trim();
      txtciudad.current.value = props.ret.ciudad.trim();
      txtEstado.current.value = props.ret.estado.trim();
      txtmunicipio.current.value = props.ret.municipio.trim();
      txtCodArea.current.value = props.ret.telefono.trim().substring(0, 4);
      txttelefono.current.value = props.ret.telefono.trim().substring(4, 11);
      txttipocontribnac.current.value = props.ret.tipocontribnac;
      txtoficinaregistro.current.value = props.ret.oficinaregistro.trim();
      txtfecharegistro.current.value = props.ret.fecharegistro.trim();
      txtprotocolo.current.value = props.ret.protocolo.trim();
      txttomo.current.value = props.ret.tomo.trim();
      txtfolio.current.value = props.ret.folio.trim();
      txtnumero.current.value = props.ret.numero.trim();
      txtcorreoepri.current.value = props.ret.correoepri.trim();
      txtcorreoesec.current.value = props.ret.correoesec.trim();

      setSolicitud({
        idret: props.ret.idret.trim(),
        razonsocial: props.ret.razonsocial.trim(),
        denominacioncomercial: props.ret.denominacioncomercial.trim(),
        direccion: props.ret.direccion.trim(),
        ciudad: props.ret.ciudad.trim(),
        rif: props.ret.rif.trim(),
        telefono: props.ret.telefono.trim(),
        responsable: props.ret.responsable.trim(),
        fechaincripcion: props.ret.fechaincripcion,
        cappagado: props.ret.cappagado.trim(),
        capsubsc: props.ret.capsubsc.trim(),
        tipocontribnac: props.ret.tipocontribnac,
        status: props.ret.status,
        oficinaregistro: props.ret.oficinaregistro.trim(),
        fecharegistro: props.ret.fecharegistro.trim(),
        protocolo: props.ret.protocolo.trim(),
        tomo: props.ret.tomo.trim(),
        folio: props.ret.folio.trim(),
        numero: props.ret.numero.trim(),
        correoepri: props.ret.correoepri.trim(),
        correoesec: props.ret.correoesec.trim(),
        municipio: props.ret.municipio.trim(),
        estado: props.ret.estado.trim(),
        nacrepre: props.ret.nacrepre.trim(),
      });

      datosRes(props.ret.nacrepre.trim(), props.ret.responsable.trim());
    } else {
      txtcapsubsc.current.value = "0,00";
      txtcappagado.current.value = "0,00";
      txtrazonsocial.current.value = "";
      txtdenominacioncomercial.current.value = "";
      txtdireccion.current.value = "";
      txtciudad.current.value = "";
      txtEstado.current.value = "";
      txtmunicipio.current.value = "";
      txtrif.current.value = "";
      txtCodArea.current.value = "";
      txttelefono.current.value = "";
      txttipocontribnac.current.value = "";
      txtoficinaregistro.current.value = "";
      txtfecharegistro.current.value = "";
      txtprotocolo.current.value = "";
      txttomo.current.value = "";
      txtfolio.current.value = "";
      txtnumero.current.value = "";
      txtcorreoepri.current.value = "";
      txtcorreoesec.current.value = "";

      setSolicitud({
        idret: 0,
        razonsocial: "",
        denominacioncomercial: "",
        direccion: "",
        ciudad: "",
        rif: "",
        telefono: "",
        responsable: "",
        fechaincripcion: "",
        cappagado: "0,00",
        capsubsc: "0,00",
        tipocontribnac: "",
        status: "",
        oficinaregistro: "",
        fecharegistro: "",
        protocolo: "",
        tomo: "",
        folio: "",
        numero: "",
        correoepri: "",
        correoesec: "",
        municipio: "",
        estado: "",
        nacrepre: "",
      });
    }
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={llenarCampos}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Solicitud de Registro</h3>
        </div>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={() => props.onHide(false)}
        >
          <i className="fas fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="col-md-12">
          <fieldset className=" row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between">
            <legend
              className="float-none w-auto fw-bold"
              style={{ fontSize: "16px" }}
            >
              Datos del Contribuyente
            </legend>
            <div className="input-group input-group-sm col-md-3 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Rif:
              </span>
              <select
                title="seleccione el tipo de rif"
                disabled={habilitado}
                ref={txtTipoRif}
                name="tiporif"
                onChange={onChangeSolicitud}
                className="form-select form-select-sm col-md-3 text-center"
                aria-label="form-select-sm example"
              >
                <option key={0} value="">
                  --
                </option>
                <option key={1} value="J">
                  J
                </option>
                <option key={2} value="G">
                  G
                </option>
                <option key={3} value="V">
                  V
                </option>
                <option key={4} value="P">
                  P
                </option>
              </select>
              <input
                type="text"
                autoComplete="off"
                maxLength={9}
                ref={txtrif}
                disabled={habilitado}
                name="rif"
                onChange={onChangeSolicitud}
                onKeyUp={validarRif}
                onBlur={validarRif}
                title="ingrese el rif"
                placeholder="ingrese el rif"
                className="col-md-9 form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

            <div className="input-group input-group-sm col-md-3 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Denominación Social:
              </span>
              <select
                ref={txtdenominacioncomercial}
                disabled={habilitado}
                value={
                  solicitud.denominacioncomercial !== null
                    ? solicitud.denominacioncomercial
                    : ""
                }
                name="denominacioncomercial"
                onChange={onChangeSolicitud}
                title="seleccione la denominacion social"
                className="form-select form-select-sm"
                aria-label="form-select-sm example"
              >
                <option value="">--seleccionar--</option>
                {denominacion &&
                  denominacion.map((item, i) => (
                    <option key={i} value={item.iddenominacioncomercial}>
                      {item.descripcion}
                    </option>
                  ))}
              </select>
            </div>
            <div className="input-group input-group-sm col-md-12 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Razón Social:
              </span>
              <input
                type="text"
                autoComplete="off"
                disabled={habilitado}
                ref={txtrazonsocial}
                value={
                  solicitud.razonsocial !== null ? solicitud.razonsocial : ""
                }
                name="razonsocial"
                onChange={onChangeSolicitud}
                title="ingrese la razon social"
                placeholder="ingrese la razon social"
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="input-group input-group-sm col-md-12 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Dirección:
              </span>
              <textarea
                type="area"
                autoComplete="off"
                disabled={habilitado}
                ref={txtdireccion}
                value={solicitud.direccion !== null ? solicitud.direccion : ""}
                name="direccion"
                onChange={onChangeSolicitud}
                title="ingrese la direccion"
                placeholder="ingrese la direccion"
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                style={{ height: 35 }}
              />
            </div>

            <div className="input-group input-group-sm col-md-3 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Estado:
              </span>
              <select
                ref={txtEstado}
                disabled={habilitado}
                value={solicitud.estado !== null ? solicitud.estado : ""}
                name="estado"
                onChange={onChangeSolicitud}
                title="seleccione el municipio"
                className="form-select form-select-sm"
                aria-label="form-select-sm example"
              >
                <option value="">--seleccionar--</option>
                {estados &&
                  estados.map((item, i) => (
                    <option key={i} value={item.idestado}>
                      {item.nombre}
                    </option>
                  ))}
              </select>
            </div>

            <div className="input-group input-group-sm col-md-3 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Municipio:
              </span>
              <select
                ref={txtmunicipio}
                disabled={habilitado}
                value={solicitud.municipio !== null ? solicitud.municipio : ""}
                name="municipio"
                onChange={onChangeSolicitud}
                title="seleccione el municipio"
                className="form-select form-select-sm"
                aria-label="form-select-sm example"
              >
                <option value="">--seleccionar--</option>
                {municipios &&
                  municipios.map((item, i) => (
                    <option key={i} value={item.idmunicipio}>
                      {item.nombre}
                    </option>
                  ))}
              </select>
            </div>

            <div className="input-group input-group-sm col-md-3 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Ciudad:
              </span>
              <select
                ref={txtciudad}
                disabled={habilitado}
                value={solicitud.ciudad !== null ? solicitud.ciudad : ""}
                onChange={onChangeSolicitud}
                title="seleccione la ciudad"
                name="ciudad"
                className="form-select form-select-sm"
                aria-label="form-select-sm example"
              >
                <option value="">--seleccionar--</option>
                {ciudades &&
                  ciudades.map((item, i) => (
                    <option key={i} value={item.idciudad}>
                      {item.nombre}
                    </option>
                  ))}
              </select>
            </div>

            <div className="input-group input-group-sm col-md-2 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Teléfono:
              </span>
              <input
                type="text"
                disabled={habilitado}
                maxLength={4}
                autoComplete="off"
                ref={txtCodArea}
                onFocus={seleccionarCampo}
                name="codarea"
                onBlur={validarNumero}
                onKeyUp={validarNumero}
                onChange={onChangeSolicitud}
                title="ingrese el codigo de area"
                placeholder="0000"
                className="form-control col-md-3"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
              <input
                type="text"
                disabled={habilitado}
                maxLength={7}
                autoComplete="off"
                ref={txttelefono}
                name="telefono"
                onChange={onChangeSolicitud}
                onBlur={validarNumero}
                onKeyUp={validarNumero}
                title="ingrese el numero de telefono"
                placeholder="1234567"
                className="form-control col-md-6"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="input-group input-group-sm col-md-6 ">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Email Principal:
              </span>
              <input
                type="text"
                disabled={habilitado}
                autoComplete="off"
                ref={txtcorreoepri}
                value={
                  solicitud.correoepri !== null ? solicitud.correoepri : ""
                }
                name="correoepri"
                onChange={onChangeSolicitud}
                title="ingrese el correo principal"
                placeholder="ingrese el correo principal"
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="input-group input-group-sm col-md-6 ">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Email Secundario:
              </span>
              <input
                type="text"
                disabled={habilitado}
                autoComplete="off"
                ref={txtcorreoesec}
                value={
                  solicitud.correoesec !== null ? solicitud.correoesec : ""
                }
                name="correoesec"
                onChange={onChangeSolicitud}
                title="ingrese el correo secundario"
                placeholder="ingrese el correo secundario"
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

            <div className="col-md-1"></div>
          </fieldset>
        </div>
        <div className="col-md-12 mt-2">
          <fieldset className=" row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between">
            <legend
              className="float-none w-auto fw-bold"
              style={{ fontSize: "16px" }}
            >
              Datos del Responsable
            </legend>

            <div className="input-group input-group-sm col-md-3 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Cedula:
              </span>
              <select
                title="seleccione la nacionalidad"
                disabled={habilitado}
                ref={txtNacionalidad}
                /* value={persona.nacionalidad !== null ? persona.nacionalidad : ''}  */ name="nacionalidad"
                onChange={onChange}
                className="form-select form-select-sm col-md-3 text-center"
                aria-label="form-select-sm example"
              >
                <option key={0} value="">
                  --
                </option>
                <option key={1} value="V">
                  V
                </option>
                <option key={2} value="E">
                  E
                </option>
              </select>
              <input
                type="text"
                disabled={habilitado}
                title="ingrese el numero de cedula"
                ref={txtCedula}
                maxLength={14}
                className="col-sm-9 form-control form-control-sm"
                autoComplete="off"
                /* value={persona.cedula !== null ? persona.cedula : ''}  */ placeholder="123456789"
                name="cedula"
                onChange={onChange}
                onKeyUp={validarPersona}
                onBlur={validarPersona}
                id="inputCedrespon"
              />
            </div>

            <div className="input-group input-group-sm col-md-3 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Nombres:
              </span>
              <input
                type="text"
                title="ingrese los nombres"
                placeholder="ingrese los nombres"
                disabled={!habilitadoNU}
                ref={txtNombreRespon}
                /* value={persona.nombres !== null ? persona.nombres : ''} */ name="nombres"
                onChange={onChange}
                autoComplete="off"
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="input-group input-group-sm col-md-3 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Apellidos:
              </span>
              <input
                type="text"
                title="ingrese los apellidos"
                placeholder="ingrese los apellidos"
                disabled={!habilitadoNU}
                ref={txtApellidos}
                /* value={persona.apellidos !== null ? persona.apellidos : ''}  */ name="apellidos"
                onChange={onChange}
                autoComplete="off"
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="input-group input-group-sm col-md-2 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Sexo:
              </span>
              <select
                title="ingrese el sexo"
                placeholder="ingrese el sexo"
                disabled={!habilitadoNU}
                ref={txtSexo}
                /*  value={persona.sexo !== null ? persona.sexo : ''} */ name="sexo"
                onChange={onChange}
                autoComplete="off"
                className="form-select form-select-sm text-center"
                aria-label="form-select-sm example"
              >
                <option key={0} value="">
                  --
                </option>
                <option key={1} value="M">
                  M
                </option>
                <option key={2} value="F">
                  F
                </option>
              </select>
            </div>

            <div className="input-group input-group-sm col-md-12 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Dirección:
              </span>
              <textarea
                type="area"
                title="ingrese la direcccion"
                placeholder="ingrese la direcccion"
                disabled={!habilitadoNU}
                ref={txtDireccionRespon}
                /* value={persona.direccion !== null ? persona.direccion : ''} */ name="direccion"
                onChange={onChange}
                autoComplete="off"
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                style={{ height: 35 }}
              />
            </div>

            <div className="input-group input-group-sm col-md-3 ">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Fecha de Nacimiento:
              </span>
              <input
                type="date"
                max={fechaTope}
                title="ingrese la fecha de nacimiento"
                placeholder="ingrese la fecha de nacimiento"
                disabled={!habilitadoNU}
                ref={txtFnacimiento}
                /*  value={persona.fnacimiento !== null ? persona.fnacimiento : ''} */ name="fnacimiento"
                onChange={onChange}
                autoComplete="off"
                className="form-control "
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="input-group input-group-sm col-md-5 ">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Email:
              </span>
              <input
                type="text"
                title="ingrese el correo"
                placeholder="ingrese el correo"
                disabled={!habilitadoNU}
                ref={txtCorreoRespon}
                /* value={persona.correoe !== null ? persona.correoe : ''} */ name="correoe"
                onChange={onChange}
                autoComplete="off"
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="input-group input-group-sm col-md-2 ">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Telefono:
              </span>
              <input
                type="text"
                title="ingrese el codigo"
                maxLength={4}
                placeholder="0000"
                onFocus={seleccionarCampo}
                disabled={!habilitadoNU}
                ref={txtTlf1Area}
                /*  value={persona.tlf1 !== null ? persona.tlf1 : ''} */ name="tlf1area"
                onBlur={validarNumero}
                onKeyUp={validarNumero}
                onChange={onChange}
                autoComplete="off"
                className="form-control col-md-3"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
              <input
                type="text"
                title="ingrese el numero de telefono"
                maxLength={7}
                onFocus={seleccionarCampo}
                placeholder="1234567"
                disabled={!habilitadoNU}
                ref={txtTlf1}
                /*  value={persona.tlf1 !== null ? persona.tlf1 : ''} */ name="tlf1"
                onBlur={validarNumero}
                onKeyUp={validarNumero}
                onChange={onChange}
                autoComplete="off"
                className="form-control col-md-6"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="input-group input-group-sm col-md-2 ">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Celular:
              </span>
              <input
                type="text"
                title="ingrese el codigo"
                maxLength={4}
                placeholder="0000"
                onFocus={seleccionarCampo}
                disabled={!habilitadoNU}
                ref={txtTlf2Area}
                /*  value={persona.tlf1 !== null ? persona.tlf1 : ''} */ name="tlf2area"
                onBlur={validarNumero}
                onKeyUp={validarNumero}
                onChange={onChange}
                autoComplete="off"
                className="form-control col-md-3"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
              <input
                type="text"
                title="ingrese el numero de celular"
                maxLength={7}
                onFocus={seleccionarCampo}
                placeholder="1234567"
                disabled={!habilitadoNU}
                ref={txtTlf2}
                /* value={persona.tlf2 !== null ? persona.tlf2 : ''} */ name="tlf2"
                onBlur={validarNumero}
                onKeyUp={validarNumero}
                onChange={onChange}
                autoComplete="off"
                className="form-control col-md-6"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
          </fieldset>
        </div>

        <div className="col-md-12 mt-2">
          <fieldset className=" row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between">
            <legend
              className="float-none w-auto fw-bold"
              style={{ fontSize: "16px" }}
            >
              Datos del Registro Mercantil
            </legend>

            <div className="input-group input-group-sm col-md-3 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Fecha de Registro:
              </span>
              <input
                type="date"
                autoComplete="off"
                disabled={habilitado}
                max={moment(fechaSistema).format("YYYY-MM-DD")}
                ref={txtfecharegistro}
                value={
                  solicitud.fecharegistro !== null
                    ? moment(solicitud.fecharegistro).format("YYYY-MM-DD")
                    : ""
                }
                name="fecharegistro"
                onChange={onChangeSolicitud}
                title="ingrese la fecha del registro"
                className="form-control "
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="col-md-1" />
            <div className="input-group input-group-sm col-md-2 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Protocolo:
              </span>
              <input
                type="text"
                autoComplete="off"
                disabled={habilitado}
                ref={txtprotocolo}
                value={solicitud.protocolo !== null ? solicitud.protocolo : ""}
                name="protocolo"
                onChange={onChangeSolicitud}
                title="ingrese el protocolo"
                placeholder="ingrese el protocolo"
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="input-group input-group-sm col-md-2 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Tomo N°:
              </span>
              <input
                type="text"
                autoComplete="off"
                disabled={habilitado}
                ref={txttomo}
                value={solicitud.tomo !== null ? solicitud.tomo : ""}
                name="tomo"
                onChange={onChangeSolicitud}
                title="ingrese el numero de tomo"
                placeholder="ingrese el numero de tomo"
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="input-group input-group-sm col-md-2 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Folio:
              </span>
              <input
                type="text"
                autoComplete="off"
                disabled={habilitado}
                ref={txtfolio}
                value={solicitud.folio !== null ? solicitud.folio : ""}
                name="folio"
                onChange={onChangeSolicitud}
                title="ingrese el folio"
                placeholder="ingrese el folio"
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="input-group input-group-sm col-md-2 mb-3">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Registro N°:
              </span>
              <input
                type="text"
                autoComplete="off"
                disabled={habilitado}
                ref={txtnumero}
                value={solicitud.numero !== null ? solicitud.numero : ""}
                name="numero"
                onChange={onChangeSolicitud}
                title="ingrese el numero de registro"
                placeholder="ingrese el numero de registro"
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="input-group input-group-sm col-md-3 ">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Oficina de Registro:
              </span>
              <input
                type="text"
                autoComplete="off"
                disabled={habilitado}
                ref={txtoficinaregistro}
                value={
                  solicitud.oficinaregistro !== null
                    ? solicitud.oficinaregistro
                    : ""
                }
                name="oficinaregistro"
                onChange={onChangeSolicitud}
                title="ingrese la oficina de registro"
                placeholder="ingrese la oficina de registro"
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="input-group input-group-sm col-md-2 ">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Capt. Subscrito:
              </span>
              <input
                type="text"
                autoComplete="off"
                disabled={habilitado}
                ref={txtcapsubsc}
                onFocus={seleccionarCampo}
                onBlur={handleInputMontoChange}
                onKeyUp={handleInputMontoChange}
                name="capsubsc"
                title="ingrese el capital subscrito"
                placeholder="ingrese el capital subscrito"
                className="form-control text-end"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="input-group input-group-sm col-md-2 ">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Capt. Pagado:
              </span>
              <input
                type="text"
                autoComplete="off"
                disabled={habilitado}
                ref={txtcappagado}
                onFocus={seleccionarCampo}
                onBlur={handleInputMontoChange}
                onKeyUp={handleInputMontoChange}
                name="cappagado"
                title="ingrese el capital pagado"
                placeholder="ingrese el capital pagado"
                className="form-control text-end"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            <div className="input-group input-group-sm col-md-3 ">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Tipo Contribuyente:
              </span>
              <select
                ref={txttipocontribnac}
                disabled={habilitado}
                value={
                  solicitud.tipocontribnac !== null
                    ? solicitud.tipocontribnac
                    : ""
                }
                name="tipocontribnac"
                onChange={onChangeSolicitud}
                title="ingrese el tipo de contribuyente"
                className="form-select form-select-sm"
                aria-label="form-select-sm example"
              >
                <option value="">--seleccione el tipo--</option>
                {tipocontribuyente &&
                  tipocontribuyente.map((item, i) => (
                    <option key={i} value={item.idtipocontribuyente}>
                      {item.descripcion}
                    </option>
                  ))}
              </select>
            </div>
          </fieldset>
        </div>
        <div className="col-md-12 mt-2" style={{ visibility: visible }}>
          <fieldset className=" row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between">
            <legend
              className="float-none w-auto fw-bold"
              style={{ fontSize: "16px" }}
            >
              Actividad Comercial
            </legend>

            <div className="col-md-12 mx-auto">
              <div className="col-12 p-2">
                <div className="row col-12 d-flex justify-content-end">
                  <div className="col-3 d-flex justify-content-end">
                    <button
                      onClick={() => setMostrar5(true)}
                      disabled={habilitado}
                      className="btn btn-sm btn-primary rounded-pill"
                    >
                      <i className="fas fa-plus"> agregar actividad</i>{" "}
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-12 m-0">
                <TblContainer
                  container={{
                    maxHeight: 200,
                    width: "100%",
                    overflow: "auto",
                  }}
                >
                  <TblHead />
                  <TableBody>
                    {records &&
                      records.map((item, index) => (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell
                            className="align-baseline"
                            style={{
                              textAlign: "center",
                              alignItems: "center",
                              border: "solid 1px blue",
                              borderLeft: "none",
                            }}
                          >
                            {item.idactividad}{" "}
                          </TableCell>
                          <TableCell
                            className="align-baseline"
                            style={{
                              textAlign: "center",
                              alignItems: "center",
                              border: "solid 1px blue",
                            }}
                          >
                            {item.codigoactividad}{" "}
                          </TableCell>
                          <TableCell
                            className="align-baseline"
                            style={{
                              textAlign: "start",
                              alignItems: "center",
                              border: "solid 1px blue",
                              width: "70%",
                            }}
                          >
                            {item.descripcion}{" "}
                          </TableCell>
                          <TableCell
                            className="align-baseline"
                            style={{
                              textAlign: "center",
                              alignItems: "center",
                              border: "solid 1px blue",
                              borderRight: "none",
                            }}
                          >
                            <button
                              onClick={eliminarActividad(item)}
                              disabled={habilitado}
                              className="btn btn-sm mx-1 btn-danger rounded-circle"
                            >
                              <i className="fa fa-trash"></i>{" "}
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
              </div>
            </div>
          </fieldset>
        </div>

        <CatalogoActividades
          show={mostrar5}
          onHideAceptaCatAct={handleAceptaCatalogoAct}
          onHideCancelar={() => setMostrar5(false)}
        />

        <CatalogoResponExpendio
          show={catalogo}
          onHideCancelaCatPer={() => setCatalogo(false)}
          onHideAceptaCatPer={handleAceptaCatalogoPer}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />

        <Dimmer active={activate} />
      </Modal.Body>
      <Modal.Footer>
        <div className="col-md-12 d-flex justify-content-end mt-3">
          <button
            type="button"
            onClick={onChangeValidar}
            disabled={props.operacion === 3 ? false : habilitado}
            className="btn btn-sm rounded-pill mx-2 btn-success"
          >
            <i className="fas fa-check-circle me-2">Aceptar</i>
          </button>
          <button
            type="button"
            onClick={() => props.onHide(false)}
            className="btn btn-sm rounded-pill mx-2 btn-danger"
          >
            <i className="fas fa-times-circle me-2">Cancelar</i>
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default FormTributario;



// WEBPACK FOOTER //
// ./src/components/registroEstadalTributario/formRegistroTribu.js